/** @jsx jsx */
import { jsx } from "theme-ui"
import Menu from "../components/menu"
import COUNTRIES from "../COUNTRIES"
import OUTPUT_COUNTRIES from "../../OUTPUT_countries.json"

const directionLinks = [
  { name: "Egipt 🇪🇬", link: "/wakacje/egipt" },
  { name: "Turcja 🇹🇷", link: "/wakacje/turcja" },
  { name: "Hiszpania 🇪🇸", link: "/wakacje/hiszpania" },
  { name: "Grecja 🇬🇷", link: "/wakacje/grecja" },
  { name: "Cypr 🇨🇾", link: "/wakacje/cypr" },
  { name: "Bułgaria 🇧🇬", link: "/wakacje/bulgaria" },
  { name: "Tunezja 🇹🇳", link: "/wakacje/tunezja" },
  { name: "Malediwy 🇲🇻", link: "/wakacje/malediwy" },
  { name: "Malezja 🇲🇾", link: "/wakacje/malezja" },
  { name: "Tajlandia 🇹🇭", link: "/wakacje/tajlandia" },
  { name: "Portugalia 🇵🇹", link: "/wakacje/portugalia" },
  { name: "Chorwacja 🇭🇷", link: "/wakacje/chorwacja" },
  { name: "Włochy 🇮🇹", link: "/wakacje/wlochy" },
  { name: "Francja 🇫🇷", link: "/wakacje/francja" },
  { name: "Albania 🇦🇱", link: "/wakacje/albania" },
  { name: "Pokaż wszystkie 🔽", link: "/wakacje" },
]

const otherLinks = [
  // {
  //   name: "Wyjazdy na mecze ⚽︎",
  //   link: "https://wyjazdnamecz.pl",
  //   inNewTab: true,
  // },
  {
    name: "Parkingi przy lotnisku",
    link: "https://baliceparking.pl",
    inNewTab: true,
  },
  { name: "RODO", link: "/rodo" },
  { name: "Polityka Prywatności", link: "/polityka-prywatnosci" },
  { name: "Regulamin", link: "/regulamin" },
  { name: "Kontakt", link: "/kontakt" },
]
export const navLinks = [
  { name: "Home", link: "/" },
  { name: "Oferty", link: "/wakacje/" },
  { name: "Last minute", link: "/wakacje/last-minute" },
  // { name: "Last minute Tunezja", link: "/wakacje-tunezja-last-minute" },
  { name: "All inclusive", link: "/wakacje/all-inclusive" },

  {
    custom: true,
    component: () => (
      <Menu
        key="direction-links"
        links={directionLinks}
        title="Popularne Kierunki ⬇"
      />
    ),
  },
  { name: "Blog", link: "/blog" },
  // { name: 'Egzotyka', link: '/egzotyka' },
  // { name: 'Lato 2023', link: '/lato2023' }, - nie da rady bo url sie nie stworzy, ale nie testowano
  // { name: 'Wycieczki objazdowe', link: '/wycieczki-objazdowe' },
  {
    custom: true,
    component: () => (
      <Menu key="other-links" links={otherLinks} title="Inne ⬇" />
    ),
  },
  // { custom: true, component: Tui },
]

export const CTA_TEXT = "Pokaż oferty"

export const sendClickOfferTrackingEvents = (offer, url = "") => {
  try {
    if (window && window.gtag && typeof window.gtag === "function") {
      var callback = function () {
        if (typeof url != "undefined") {
          window.location = url
        }
      }
      // eslint-disable-next-line no-undef
      window.gtag("event", "click-offer", {
        event_category: "click-offer",
        event_label: offer.link,
        event_callback: callback,
      })
      // window.gtag("event", "conversion", {
      //   send_to: "AW-321714797/NNojCICAhqkZEO30s5kB",
      //   event_callback: callback,
      //   event_label: offer.link,
      // })

      window.gtag("event", "purchase", {
        transaction_id: "T_12345",
        value: offer.price,
        currency: "PLN",
        items: [
          {
            id: offer.id,
            name: offer.name,
            category: offer.category,
            quantity: 1,
            price: offer.price,
          },
        ],
        tt_external_id:
          "b9c5fdaea74ee1c31705b764389895371b8d416c5cae8740e7f89082a9fcdc0a",
        tt_content_type: "product",
      })
    }
  } catch (error) {
    console.error("sendClickOfferTrackingEvents", error)
  }
  try {
    if (window?.fbq && typeof window.fbq === "function") {
      // eslint-disable-next-line no-undef
      window.fbq("track", "Purchase", {
        content_ids: offer.id,
        value: offer.price,
        currency: "PLN",
        content_type: "product",
        content_name: offer.name,
      })
    }
  } catch (error) {
    console.error("sendClickOfferTrackingEvents", error)
  }
  try {
    if (window?.uetq) {
      window.uetq = window.uetq || []
      window?.uetq?.push("event", "outbound_click", {
        event_label: offer.link,
        event_category: "click-offer",
      })
    }
  } catch (error) {
    console.error("sendClickOfferTrackingEvents", error)
  }
}

const MOST_POPULAR_COUNTRIES_IDS = [
  "33",
  "110",
  "305",
  "29",
  "31",
  "32",
  "86",
  "16",
  "37",
]
export const MOST_POPULAR_COUNTRIES = COUNTRIES.filter(country =>
  MOST_POPULAR_COUNTRIES_IDS.includes(country.value)
).filter(Boolean)

export const prepareExtraData = pl_country_name => {
  const foundExtraData = OUTPUT_COUNTRIES.find(
    country => country.pl_name.toLowerCase() === pl_country_name
  )
  const poland = OUTPUT_COUNTRIES.find(country => country.pl_name === "Polska")

  const foundCountry = COUNTRIES.find(
    country => country.label.toLowerCase() === pl_country_name
  )

  const {
    code: countryInternalCode,
    labelWhere,
    urlName,
    getYourGuideId,
    regions,
    noPassport,
  } = foundCountry

  return {
    ...foundExtraData,
    noPassport,
    regions,
    poland,
    countryInternalCode,
    labelWhere,
    getYourGuideId,
    urlName,
  }
}
